import { Component } from '@angular/core';
import {
  PoBreadcrumb,
  PoButtonModule,
  PoDynamicFormField,
  PoModalModule,
  PoPageModule,
  PoTableColumn,
} from '@po-ui/ng-components';
import { PoDynamicModule } from '@po-ui/ng-components';
import { DynamicTableComponent } from '../../dynamic-table/dynamic-table.component';
import { ExportModalComponent } from '../../components/modal/export-modal/export-modal.component';

@Component({
  selector: 'app-active-contracts',
  standalone: true,
  imports: [
    DynamicTableComponent,
    PoPageModule,
    PoButtonModule,
    PoModalModule,
    PoDynamicModule,
    ExportModalComponent
  ],
  templateUrl: './active-contracts.component.html',
  styleUrl: './active-contracts.component.scss',
})
export class ActiveContractsComponent {
  constructor() { }

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      {
        label: 'Início',
        link: '/',
      },
      {
        label: 'Contratos Ativos',
      },
    ],
  };


  public readonly exportUrlApi = '/contract/activeContracts/download';
  public readonly exportFormFields: PoDynamicFormField[] = [
    {
      property: 'fileType',
      label: 'Escolha o formato que deseja exportar',
      required: true,
      gridColumns: 12,
      options: [
        {
          label: 'PDF',
          value: 'pdf',
        },
        {
          label: 'XLSX',
          value: 'xlsx',
        },
        {
          label: 'CSV',
          value: 'csv',
        },
      ],
      errorMessage: 'Esse campo é obrigatório.'
    }
  ];

  search: string | undefined = undefined;

  tableColumns: PoTableColumn[] = [
    {
      label: 'Atualizado em',
      property: 'updatedAt',
      type: 'date',
      format: 'dd/MM/yyyy',
    },
    {
      label: 'CNPJ',
      property: 'client.document',
    },
    { label: 'Nome do cliente', property: 'client.name' },
    { label: 'Qtd. de itens', property: 'totalContractItems', width: '140px' },
    {
      label: 'Valor de contrato',
      property: 'totalValueContractItems',
      type: 'currency',
      format: 'BRL',
    },
  ]

  request = {
    whereTypeName: 'ContractFilterDto',
    requestName: 'allContracts',
    requestWhere: {
      status: 'Ativo'
    },
    requestBody: `
      allContracts( pagination: $pagination, where: $where) {
        items {
          id,
          client {name, document},
          updatedAt,
          totalValueContractItems,
          totalContractItems
        },
        totalPages,
      }
 `,

  }
}
